import { Component, OnInit } from '@angular/core';
import { ExternalTokensService } from '@services/external-tokens/external-tokens.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Models } from '@ibexfusion/models';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { ProfileService } from '@services/profiles/profile.service';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { SnackbarService } from '@services/snackbar/snackbar.service';

@Component({
    selector: 'app-external-tokens-edit',
    templateUrl: './external-tokens-edit.component.html',
    styleUrls: ['./external-tokens-edit.component.scss'],
    providers: [ExternalTokensService, ProfileService],
    standalone: false
})
export class ExternalTokensEditComponent implements OnInit {

  title = 'Edit token';
  tokenId: string;
  token: Models.ExternalToken;
  isLoading = true;
  pageActions: PageAction[];
  create = false;
  filteredProfiles: Models.Profile[];
  profile: Models.Profile;
  currentSearchTerm = null;

  constructor(
    private tokenService: ExternalTokensService,
    private activatedRoute: ActivatedRoute,
    private profileService: ProfileService,
    private snackbar: SnackbarService,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.createPageActions();
    if (this.activatedRoute.snapshot.params['id']) {
      this.tokenId = this.activatedRoute.snapshot.params['id'];
      this.tokenService.get(this.tokenId).then(result => {
        this.token = result;
        this.isLoading = false;
      });
    } else {
      this.title = 'Create new token';
      this.create = true;
      this.token = <Models.ExternalToken>Models.ModelFactory.createModelInstanceByName('ExternalToken');
      this.isLoading = false;
    }
  }

  createPageActions() {
    this.pageActions = [
      new PageAction({
        icon: 'save',
        title: 'Save token',
        callback: () => {
          this.onSave();
        }
      }),
      new PageAction({
        icon: 'subdirectory_arrow_left',
        title: 'Overview tokens',
        callback: () => {
          this.router.navigate(['external-tokens']);
        }
      })
    ];
  }

  onSave() {
    return this.token.validate(true).then(result => {
      if (result.success) {
        for (let i = 0; i < this.token.parameters.length; i++) {
          if (!this.token.parameters[i].name || !this.token.parameters[i].value) {
            this.token.parameters.splice(i, 1);
            i--;
          }
        }
        if (this.tokenId) {
          this.tokenService.update(this.tokenId, this.token).then();
        } else {
          this.tokenService.create(this.token).then();
        }
      } else {
        this.snackbar.open('Could not create the token, please fill in the form correctly');
      }
    });
  }

  addProfile(event: MatAutocompleteSelectedEvent) {
    const profileId = event.option.value;
    this.token.ProfileID = profileId;
    this.profileService.get(profileId).then(res => {
      this.profile = res;
      this.token.email = res.email;
    });
    this.currentSearchTerm = null;
  }

  filterProfiles(value: string) {
    this.profileService.find(0, 20, {
      $and: [
        { isAnonymous: 0 },
        { userType: 'ibexfusion' },
        {
          $or: [
            { firstName: { $like: '%' + value + '%' } },
            { lastName: { $like: '%' + value + '%' } },
            { nickName: { $like: '%' + value + '%' } }
          ]
        }
      ]
    }).then(result => {
      this.filteredProfiles = result.data;
    });
  }

  addParameter() {
    if (!this.token.parameters) {
      this.token.parameters = [];
    }
    this.token.parameters.push(new Models.LoginParameter());
  }

  removeParameter(index) {
    this.token.parameters.splice(index, 1);
  }

}
